import React, { PureComponent } from 'react';
// import { loadStripe } from '@stripe/stripe-js';
import RetinaImage from 'react-retina-image';
import toastr from 'toastr';
import { getJwt } from '../../services/authService';
import http from '../../services/httpService';
import countries from '../common/countriesEuVat.json';
import { Button, MenuItem } from '@blueprintjs/core';
import { Select } from '@blueprintjs/select';
import InputRegular from '../common/InputRegular';
import StripeReplacementModal from '../modals/StripeReplacementModal';

const temporaryBearer = process.env.REACT_APP_ENVIRONMENT === 'PROD'?
    'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIyIiwianRpIjoiMDYxOTBhOWI1NWNkY2Q3OTViZmQ2Nzg5Y2UxODYxZmFlNjU3MWE5MDNhZTI5ZTQwYmZkYmRlYmZmZWEyMTE3NzU4ODEyYTVmYTkzY2Q1YmEiLCJpYXQiOjE2MTY0MTYwNzQsIm5iZiI6MTYxNjQxNjA3NCwiZXhwIjoxNjQ3OTUyMDc0LCJzdWIiOiIyNDgiLCJzY29wZXMiOlsiKiJdfQ.er_2b5Q1N2v6zsr40nj5EWm5Mqfs74qx6KXEuhYgfuK9G7ish2kT_tecF_JzE39jFanSgWeqK-ifaAqGeMFg-jKb2Q_ujjsQjNl-dIp6VmtzpIMCvA_bMR7ehVjaP_q5XWhO4iXpdyt3Wn7spvpLsNgSw6VH-DhnS1xdaR0OpoGQO-sM2sJumqxlu1MyxocL2jSAXXxkA6bujueRU-cOZR0o3kNtwm42_i_jfUIZkCNuj8wwcLussVQ4KcAIsUeNZ1hAqo1Pyq7kNDO-Lo5xBIoCSHUOOuTUzZnpWZJWQdoGvuFcjo17lYRrCgxZQI3FGaQ6JSf3YLpZPlHWuh9nPEf3KaY-k6LIoi5mN1dBlmJ7QlLiRt_-QMt1daZu7a34uz2gWPq6gWppB7SQmXa5MX4JVU_pO8P3Nk-CkuXbUsZEksXJLtQveJpm8nIC9OLjLRe0hb9vu9FzbP5VV8IxyHZNul6pt5tHaBn50DjJgxpQTPhVFtyx_aHC3CkvgwKalzghk_FzEc7eq-dA83xyQ8SMgevrm26rJJxvelQZiXVOxtAJbTokqXnyilAkN_AaHuIirg_k0QPHFKLwNI8Z1xcBI9c2qv3XE3iNfrY2WDipes3odOwMllBGPaMXpa6auj-nNukZQOiDbivP3D01G1ErPdiTj9vo-qjC2bKmsQc'
    :
    'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIyIiwianRpIjoiYzg2YjhiMTE5NTM3MTQ5MDgyNWE3NDlhY2VhZGNlZWUzMzQ2NTFmNzg5OTExMGUwMDhhMDJhNDdlZDM0MmEyNGE4ODNiYzNhYjVmYTVhMjEiLCJpYXQiOjE2MTYxNjIzOTgsIm5iZiI6MTYxNjE2MjM5OCwiZXhwIjoxNjQ3Njk4Mzk4LCJzdWIiOiI3NTIiLCJzY29wZXMiOlsiKiJdfQ.O6iyAHJdxwFrY-FD-F7TsV89amuGgkzDUvX0i04oR-V4VQMTXTxjS3h5SzZKXvOr_4kuEtvGvCf4Xx0MaHJ3kyfCiar9GcdwohBeRru-i-UPXcF4LpclMS5b_Gldev6AUyEVw7XxqUzPEssepi9EshOWDe4y8JYt9u8J0k3ogj81LG7GDRCu4cCD9T09bjor6sToQz23Q3GpZKabk5IcGI93X5i1t9J_DUFre4e8dKHt2cFuF7n7QJ6oEgn7u9x5p_ViDrn9ZSGdB9RoYxnpHmwHFZbSiF33PuDX7rnEtv5J_SvUZGl10L0wIIKQenKKNm_IS_zx6e1N-6xINMjeaWoaFrmRJuN7m1GqmbCYGsvHxa4U0SfLdRtzwb-v96iPOPUaV8uRRxtzDQSiWdyJ7ZAIK9DSDkov66lJBatw86bpIF9J0cMca4FBaK-xD516_hywl34wD5olBzgUWbuG19i65UomE1DSTm0Re0ZTbIEQwCvEhev8b_sWp4STt7g_h24fiGMWZFruibCyXslLHGcN_442XVmAG5i0YCs3R_vxAfMG2OU75oAJvbTo-cLV5auX3H76jXGegvkFBrJ6o0Kv9wZ95Q3ff0zVatBFRO7ZiaF-1HKk082eg1JHbTZqbsF1QWPCPWiXCRgtoWecFvs1R5JXSxQSg-7cgvG_Ttg'
const environment = process.env.REACT_APP_ENVIRONMENT;

export default class Checkout extends PureComponent{
    state = {
        error: '',
        counter: 3,
        checkoutAlreadyRun: false,
        selectedOption: '',
        countryName: 'Select Country',
        countryCode: '',
        filteredCountries: countries,
        vatId: '',
        errorsList: [],
        fieldsCheckActive: false,
        loader: false,
        vatInvalid: false,
        anyOtherLoader: false,
        stripeReplacementModal: false
    }

    handleCheckout = async () =>{
        // if(!this.state.checkoutAlreadyRun){
        const search = await window.location.search;
        // await this.setState({checkoutAlreadyRun: true})

        const params = new URLSearchParams(search);
        const plan = await params.get('plan');

        if(this.state.selectedOption === 'EuRegistered'){
            await this.setState({loader: true, vatInvalid: false, fieldsCheckActive: true})
            let anyErrorActive = await false;
            await this.state.errorsList.map(error=>error ? anyErrorActive = true : '')

            // console.log('check: ', !anyErrorActive, this.state.countryCode, this.state.vatId)
            if(!anyErrorActive && this.state.countryCode && this.state.vatId){
                try {
                    const checkVatResult = await http.post('api/test_vat', {
                        "vat_number": this.state.vatId,
                        // "country": this.state.countryCode
                    }, { headers: { authorization: temporaryBearer } });
                    // console.log('checkVatResult: ', checkVatResult)
                    if(checkVatResult.data.vat_details && checkVatResult.data.vat_details.valid){
                        if(plan){
                            let price = environment === 'PROD' ? plan === '100' ? 'price_1IYWuuK5UACAN2bB8G7JoV4k' :
                                await plan === '1' ? 'price_1IXqPgK5UACAN2bBdTJOQrtJ' : plan === '2' ? 'price_1IXqPgK5UACAN2bBNNgdU9IM' :
                                    plan === '3' ? 'price_1IXqPgK5UACAN2bBkcIbAx6r' : plan === '4' ? 'price_1IXqPgK5UACAN2bBBUM7Ggoe' :
                                        plan === '5' ? 'price_1IXqPgK5UACAN2bBHnndu3yc' : 'price_1IXqPgK5UACAN2bBI9mdmIb1' :
                                await plan === '1' ? 'price_1ITaAqK5UACAN2bBweffOtSz' : plan === '2' ? 'price_1ITaAqK5UACAN2bBnx4D1V62' :
                                    plan === '3' ? 'price_1ITaAqK5UACAN2bB9rTwclD6' : plan === '4' ? 'price_1ITqANK5UACAN2bB8Em3MT7l' :
                                        plan === '5' ? 'price_1ITqAuK5UACAN2bBAnXktLbx' : 'price_1ITqBAK5UACAN2bBiOvYoP1I';

                            let codesToGenerate = await plan === '1' ? '1' : plan === '2' ? '2' :
                                plan === '3' ? '3' : plan === '4' ? '9' :
                                    plan === '5' ? '15' : '30';

                            let successUrl = await environment === 'PROD' ?
                                'https://app.emitto.io/martech-ltd-success'
                                :
                                // 'https://localhost:3000/martech-ltd-success'
                                'https://dev-react.emitto.io/martech-ltd-success'

                            try {
                                const sessionIdResult = await http.post('api/session_create_lifetime', {
                                    price: price,
                                    plan: codesToGenerate,
                                    success_url: successUrl,
                                    apply_dynamic_tax_rates: false,
                                    vat_id: this.state.vatId
                                }, { headers: { authorization: temporaryBearer } });
                                if(sessionIdResult && sessionIdResult.data && sessionIdResult.data.session_id){
                                    this.setState({loader: false})
                                    await this.handleRedirectToCheckout(sessionIdResult.data.session_id)
                                }
                            } catch {
                                toastr.error('Creating session was unsuccessful. Please reload this page to try again.')
                                this.setState({loader: false})
                            }
                        }
                    }else{
                        this.setState({vatInvalid: true, loader: false});
                    }


                }catch{
                    toastr.error('Error with VAT validation, please try again')
                }
            }else{
                this.setState({loader: false})
            }
        } else if(this.state.selectedOption === 'AnyOther'){
            if(plan){
                this.setState({anyOtherLoader: true})
                let price = environment === 'PROD' ? plan === '100' ? 'price_1IYWuuK5UACAN2bB8G7JoV4k' :
                    await plan === '1' ? 'price_1IXqPgK5UACAN2bBdTJOQrtJ' : plan === '2' ? 'price_1IXqPgK5UACAN2bBNNgdU9IM' :
                        plan === '3' ? 'price_1IXqPgK5UACAN2bBkcIbAx6r' : plan === '4' ? 'price_1IXqPgK5UACAN2bBBUM7Ggoe' :
                            plan === '5' ? 'price_1IXqPgK5UACAN2bBHnndu3yc' : 'price_1IXqPgK5UACAN2bBI9mdmIb1' :
                    await plan === '1' ? 'price_1ITaAqK5UACAN2bBweffOtSz' : plan === '2' ? 'price_1ITaAqK5UACAN2bBnx4D1V62' :
                        plan === '3' ? 'price_1ITaAqK5UACAN2bB9rTwclD6' : plan === '4' ? 'price_1ITqANK5UACAN2bB8Em3MT7l' :
                            plan === '5' ? 'price_1ITqAuK5UACAN2bBAnXktLbx' : 'price_1ITqBAK5UACAN2bBiOvYoP1I';

                let codesToGenerate = await plan === '1' ? '1' : plan === '2' ? '2' :
                    plan === '3' ? '3' : plan === '4' ? '9' :
                        plan === '5' ? '15' : '30';

                let successUrl = await environment === 'PROD' ?
                    'https://app.emitto.io/martech-ltd-success'
                    :
                    // 'https://localhost:3000/martech-ltd-success'
                    'https://dev-react.emitto.io/martech-ltd-success'

                try {
                    const sessionIdResult = await http.post('api/session_create_lifetime', {
                        price: price,
                        plan: codesToGenerate,
                        success_url: successUrl,
                        apply_dynamic_tax_rates: true
                    }, { headers: { authorization: temporaryBearer } });
                    if(sessionIdResult && sessionIdResult.data && sessionIdResult.data.session_id){
                        this.setState({anyOtherLoader: false})
                        await this.handleRedirectToCheckout(sessionIdResult.data.session_id)
                    }
                } catch {
                    toastr.error('Creating session was unsuccessful. Please reload this page to try again.')
                    this.setState({anyOtherLoader: false})
                }
            }
        }



        // console.log('anyErrorActive: ', anyErrorActive, this.state.errorsList)


        // }

    }

    handleRedirectToCheckout = async (sessionId) => {
        // const stripePromise = await loadStripe(process.env.REACT_APP_STRIPE);
        // let stripe = await stripePromise;

        // try {
        //     const checkoutResult = await stripe.redirectToCheckout({
        //         sessionId: sessionId
        //     })
        //     if(checkoutResult.error){
        //         /*
        //          * If `redirectToCheckout` fails due to a browser or network
        //          * error, display the localized error message to your customer.
        //          */
        //         // await this.setState({
        //         //     error: checkoutResult.error.message
        //         // })
        //     }
        // } catch {
        //     toastr.error('Loading Stripe was unsuccessfull');
        // }
    }

    filterItems = (q) => {
        function escapeRegExp(s) {
            return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
        }

        const words = q
        .split(/\s+/g)
        .map(s => s.trim())
        .filter(s => !!s);
        const hasTrailingSpace = q.endsWith(" ");
        const searchRegex = new RegExp(
            words
            .map((word, i) => {
                if (i + 1 === words.length && !hasTrailingSpace) {
                    // The last word - ok with the word being "startswith"-like
                    return `(?=.*\\b${escapeRegExp(word)})`;
                } else {
                    // Not the last word - expect the whole word exactly
                    return `(?=.*\\b${escapeRegExp(word)}\\b)`;
                }
            })
            .join("") + ".+",
            "gi"
        );
        // console.log('Words: ', words)
        let filteredArray = [];
        countries.filter(item => {
            let imamIme = searchRegex.test(item.name);
            searchRegex.lastIndex = 0;
            return imamIme ? filteredArray.push(item) : null;
        });
        this.setState({
            filteredCountries: filteredArray
        })
    };

    updateErrorsList = (error, id) => {
        let errorsList = this.state.errorsList;
        errorsList[parseInt(id) - 1] = error;
        this.setState({errorsList})
        // console.log('Errors list data: ', error, id, errorsList);
    }

    componentDidMount(){
        // var counter = 3;
        // var interval = setInterval(() => {
        //     counter--;
        //     this.setState({counter})
        //     if(counter === 1){
        //         this.handleCheckout()
        //     }
        //     if (counter === 0) {
        //         clearInterval(interval);
        //     }
        // }, 1000);
    }

    render(){
        return (
            <div className="stripe-loader-redirect">
                <div className='header'>
                    <RetinaImage src={['/img/emitto-logo.png','/img/emitto-logo.svg']}  checkIfRetinaImgExists={false}/>
                </div>
                <h2>CHOOSE YOUR ENTITY</h2>
                <div className='main-container'>
                    <div className='select-container'>
                        <div
                            className={this.state.selectedOption === 'EuRegistered' ? 'single-selection active' : 'single-selection'}
                            onClick={()=>this.setState({selectedOption: 'EuRegistered'})}
                        >
                            <img src='/img/eu-flag-checkout.png'/>
                            <div className='title-container'>
                                <h3>EU REGISTERED<br/>
                                    BUSINESS</h3>
                            </div>
                            <p>If you will be making a purchase
                                as a EU Registered business only</p>
                        </div>
                        <div
                            className={this.state.selectedOption === 'AnyOther' ? 'single-selection active' : 'single-selection'}
                            onClick={()=>{
                                this.setState({selectedOption: 'AnyOther'})
                                this.handleCheckout()
                            }}
                        >
                            <img src='/img/rest-flag-checkout.png'/>
                            <div className='title-container'>
                                <h3>ANY OTHER ENTITY OR INDIVIDUAL</h3>
                            </div>
                            <p>For Businesses Worldwide (including UK)
                                or  Individuals</p>
                            {
                                this.state.anyOtherLoader ?
                                    <img className='any-other-loader-img' src="/img/chart-loader.svg" alt="Loading..." alt=""/>
                                    :
                                    ''
                            }
                        </div>
                    </div>
                    {
                        this.state.selectedOption === 'EuRegistered' ?
                            <div className='checkout-container'>
                                <h3>VAT Business details</h3>
                                <InputRegular
                                    id="1"
                                    label1="VAT ID"
                                    placeholder=""
                                    required={true}
                                    type='text'
                                    onChange={ value => this.setState({vatId: value}) }
                                    value={this.state.vatId}
                                    fieldsCheckActive={this.state.fieldsCheckActive}
                                    updateErrorsList={this.updateErrorsList}
                                    errorMessage="This field is required"
                                />
                                <Select
                                    items={this.state.filteredCountries}
                                    itemRenderer={(item, index)=> <MenuItem
                                        key={index}
                                        onClick={async () => {
                                            this.setState({
                                                countryName: item.name,
                                                countryCode: item.code
                                            })
                                        }}
                                        text={item.name + ' ' + item.flag}
                                    /> }
                                    filterable={true}
                                    onQueryChange={this.filterItems}
                                    resetOnClose={true}
                                    className='country-selector'
                                >
                                    <label style={{marginBottom: 5}}>Country</label>
                                    <Button
                                        className={(this.state.countryName === 'Select Country') && this.state.fieldsCheckActive ? 'country-selector-error' : this.state.countryName === 'Select Country' ? 'country-selector-empty' : 'country-selector'}
                                        text={ this.state.countryName }
                                        rightIcon="caret-down">
                                    </Button>

                                </Select>
                                {this.state.loader ?
                                    <button className='btn-action full-width btn-spinner' disabled={true}>Proceed to Checkout <i className='fa fa-spin fa-spinner'></i></button>
                                    :
                                    <button className='btn-action full-width' onClick={this.handleCheckout}>Proceed to Checkout</button>
                                    // <button
                                    //     className='btn-action full-width'
                                    //     onClick={()=>this.setState({stripeReplacementModal:true})}
                                    // >
                                    //     Proceed to Checkout
                                    // </button>
                                }
                                {/*<StripeReplacementModal*/}
                                {/*    showModal={this.state.stripeReplacementModal}*/}
                                {/*    handleClose={() => this.setState({stripeReplacementModal: false})}*/}
                                {/*    maxWidth={600}*/}
                                {/*    history={this.props.history}*/}
                                {/*    user={this.props.user}*/}
                                {/*    updateUserFromServer={this.props.updateUserFromServer}*/}
                                {/*/>*/}
                                <p className='grey-text text-align-center margin-top-10'>You won't be charged yet</p>

                                {
                                    this.state.vatInvalid ?
                                        <p className='red-text margin-vertical-5'>We couldn't confirm your VAT ID, please check your VAT ID and try again.</p>
                                        :
                                        ''
                                }
                            </div>
                            :
                            // this.state.selectedOption === 'AnyOther' ?
                            //     <div className='checkout-container'>
                            //         {this.state.loader ?
                            //             <button className='btn-action full-width btn-spinner' disabled={true}>Proceed to Checkout <i className='fa fa-spin fa-spinner'></i></button>
                            //             :
                            //             <button className='btn-action full-width' onClick={this.handleCheckout}>Proceed to Checkout</button>
                            //         }
                            //
                            //         <p className='grey-text text-align-center margin-top-10'>You won't be charged yet</p>
                            //     </div>
                            //     :
                            ''
                    }


                </div>
                {/*<div className='stripe-loader-container'>*/}
                {/*    <div className='stripe-loader'>*/}
                {/*    </div>*/}
                {/*    <img src="/img/stripe-logo.png" alt="Stripe Logo"/>*/}
                {/*</div>*/}
                {/*<p className='grey text-align-center'>You will be redirected to Stripe's <br/>*/}
                {/*    Secure Checkout in <span>{ this.state.counter }</span></p>*/}

            </div>
        );
    }
};
